import React from 'react';
import { theme } from '../../../../ui';
import { shadeColor } from '../../../../ui/theme/colors';
import OverviewCard from '../OverviewCard';

const LearningProgressOverview = ({ courses = [] }) => {
  const totalCourses = courses.length;
  const completedCourses = courses.filter((c) => c.progress === 1).length;
  const inProgressCourses = courses.filter((c) => c.progress > 0 && c.progress < 1).length;
  // const expiredCourses = courses.filter((c) => c.expired).length;

  const stats = [
    {
      icon: 'Course',
      label: 'COURSES',
      value: totalCourses,
      color: theme.colors.PRIMARY,
      bgColor: shadeColor(theme.colors.PRIMARY, 0.85),
    },
    {
      icon: 'Play',
      label: 'PROGRESS',
      value: inProgressCourses,
      color: theme.colors.SECONDARY,
      bgColor: shadeColor(theme.colors.SECONDARY, 0.85),
      labelColor: theme.colors.SECONDARY,
    },
    {
      icon: 'Done',
      label: 'DONE',
      value: completedCourses,
      color: theme.colors.PRIMARY,
      bgColor: shadeColor(theme.colors.PRIMARY, 0.85),
    },
    // {
    //   icon: 'Archive',
    //   label: 'EXPIRED',
    //   value: expiredCourses,
    //   color: theme.colors.NEU_600,
    //   bgColor: shadeColor(theme.colors.PRIMARY, 0.85),
    // },
  ];

  return <OverviewCard title='Your Learning Journey' stats={stats} />;
};

export default LearningProgressOverview;
